export const PLACEHOLDER_CODE = `
// JavaScript will be evaluated...
x = 1 + 1
y = x + 1
`.trim();
